import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import CustomRadio from './CustomRadio';
import Tag from './Tag';

interface OfferProps {
  offers: OfferOption[];
  selectedOfferCode: SelectedOffer['code'];
  setSelectedOffer?: (offer: SelectedOffer) => void;
}

const Offers = ({ offers, selectedOfferCode, setSelectedOffer }: OfferProps) => {
  const isSingleOffer = offers.length === 1;

  return (
    <>
      {offers.map((offer, index) => {
        const {
          benefits,
          billingFrequency,
          code,
          currentPrice,
          currentPriceDisplayOverride,
          billingFrequencyOverride,
          isBestValue,
          originalPrice,
          originalPriceDisplayOverride,
          title,
        } = offer;
        const isSelected = selectedOfferCode === code;
        const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
        const hasDiscount = originalPrice !== currentPrice;
        const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;
        return (
          <div
            key={`offer-card-${index}`}
            id={code}
            onClick={() =>
              setSelectedOffer({
                billingFrequency,
                code,
                currentPrice,
                originalPrice,
              })
            }
            className={clsx(
              'relative mb-20 block cursor-pointer rounded-10 border  border-solid border-slate-200 px-16 py-20',
              {
                'selected border-0 bg-primary-black shadow-[0_0_8px_1px_rgba(121,130,149,1)]':
                  isSelected,
                'pointer-events-none': isSingleOffer,
              }
            )}
          >
            <div className="flex items-center">
              <CustomRadio isSelected={isSelected} />
              <h2
                className={clsx('m-0 font-serif text-[26px] font-bold text-primary-black', {
                  'text-white': isSelected,
                })}
              >
                {title}
              </h2>
              {isBestValue && !isSingleOffer && <Tag name="Best Value" className="best-value" />}
              {isSingleOffer && <Tag name="Best Value" className="absolute -top-8 right-12" />}
            </div>
            <div className="mt-36 flex items-center">
              <span
                className={clsx('font-sans font-medium text-primary-black', {
                  'text-white': isSelected,
                })}
              >
                ${currentPriceToDisplay.toFixed(2)}
              </span>{' '}
              {hasDiscount && (
                <span className="ml-6 font-sans font-medium text-gray-400 line-through">
                  ${originalPriceToDisplay.toFixed(2)}
                </span>
              )}
              {billingFrequencyOverride && (
                <span
                  className={clsx('ml-6 font-sans font-medium text-primary-black', {
                    'text-white': isSelected,
                  })}
                >
                  {billingFrequencyOverride}
                </span>
              )}
            </div>
            <div
              className={clsx('mt-2 font-sans text-body-sm text-gray-500 xs:text-subtitle-serif', {
                'text-neutral-400': isSelected,
              })}
            >
              {ReactHtmlParser(benefits)}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Offers;
